export const MONTH_DATE_FORMAT = "YYYY/MM/dd";
export const DATE_TIME_FORMAT = "MM/dd HH:mm";

export const DATA_GAP = 60;